import { render, staticRenderFns } from "./MenuItems.vue?vue&type=template&id=2faa8cec&scoped=true"
import script from "./MenuItems.vue?vue&type=script&lang=js"
export * from "./MenuItems.vue?vue&type=script&lang=js"
import style0 from "./MenuItems.vue?vue&type=style&index=0&id=2faa8cec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faa8cec",
  null
  
)

export default component.exports